module.exports = __webpack_public_path__ + "static/media/Gmc_Blanc.054e3648.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/Gmc_Blanc.svg
// module id = 107
// module chunks = 0